<template>
    <div class="small mt-2">
        <div class="px-2">
            Please, make checks payable to the <b>East Central Ohio ESC.</b> Payment must be recieved within five days of enrolling in an event.
        </div>
        <div class="mt-4 mb-1">
            <span class="h6">Payments may be mailed to:</span>
        </div>
        <div class="ps-2">
            East Central Ohio ESC<br/>
            &#x2105; ECOESC Office Manager<br/>
            834 East High Ave<br>New Philadelphia, OH 44663
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
</style>